export const testType = {
    "test_type": "kiểm tra",
    "practice_type": "ôn tập",
    "exam_type": "thi cử",
    "multiple_choice": "trắc nghiệm",
    "voted": "bình chọn",
    "survey": "khảo sát",
    "multiple_choice_comparison": "trắc nghiệm so sánh",
    "multiple_choice_script" : "trắc nghiệm kịch bản",
    "multiple_choice_test": "trắc nghiệm tính điểm",
};
